import { render, staticRenderFns } from "./EditModul.vue?vue&type=template&id=396fa9ba&scoped=true"
import script from "./EditModul.vue?vue&type=script&lang=js"
export * from "./EditModul.vue?vue&type=script&lang=js"
import style0 from "./EditModul.vue?vue&type=style&index=0&id=396fa9ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396fa9ba",
  null
  
)

export default component.exports